import CM                                                  from '@emersya/mpa-components-manager-lib';

export class RadioStylizedRenderingMode extends CM.Plugin<
	InputSelectComponent
> implements TInputSelectRenderingMode {
	id = 'radio-stylized';

	getSlotDOM(component : InputSelectComponent) {
		return (component.component_DOM);
	};

	attach(component : InputSelectComponent) {
		void component;
	};

	detach(component : InputSelectComponent) {
		void component;
	};

	constructor() {
		super();
	};
};
import { InputSelectComponent, TInputSelectRenderingMode } from '../InputSelect';
